import React from 'react';
import PropTypes from 'prop-types';
import BuildingIcon from '../../../shared/components/Icons/BuildingIcon';

import './CompanyName.scss';

const CompanyName = ({ companyName, companyColor }) => (
  <div className="d-inline-flex align-items-center">
    <div
      style={{ backgroundColor: `#${companyColor}` }}
      className="company-name__icon"
    >
      <BuildingIcon />
    </div>
    <div className="company-name__name">{companyName}</div>
  </div>
);

CompanyName.propTypes = {
  companyName: PropTypes.string.isRequired,
  companyColor: PropTypes.string,
};
CompanyName.defaultProps = {
  companyColor: '8fc748',
};

export default CompanyName;
